import R2Image from '@/components/ui/R2Image';

import { cn } from './utils';

interface ResponsiveSliderImageProps {
  imagePath?: string;
  mobileImagePath?: string;
  imageAlt?: string;
  className?: string;
  imageClassName?: string;
  mobileImageClassName?: string;
  objectFit?: 'cover' | 'contain';
  priority?: boolean;
}

const ResponsiveSliderImage = ({
  imagePath,
  mobileImagePath,
  imageAlt = '',
  className,
  imageClassName,
  mobileImageClassName,
  objectFit = 'cover',
  priority = false,
}: ResponsiveSliderImageProps) => {
  if (!imagePath) return null;

  const mobilePath = mobileImagePath || imagePath;

  return (
    <div className={cn('h-full w-full overflow-hidden', className)}>
      <R2Image
        path={mobilePath}
        alt={imageAlt}
        sizes="100vw"
        containerClassName="absolute inset-0 h-full w-full tablet:hidden"
        className={cn('object-cover', mobileImageClassName ?? imageClassName)}
        objectFit={objectFit}
        priority={priority}
      />

      <R2Image
        path={imagePath}
        alt={imageAlt}
        sizes="100vw"
        containerClassName="absolute inset-0 hidden h-full w-full tablet:block"
        className={cn('object-cover', imageClassName)}
        objectFit={objectFit}
        priority={priority}
      />
    </div>
  );
};

export default ResponsiveSliderImage;
